import { render, staticRenderFns } from "./AddFlourTypeWeightLinkModal.vue?vue&type=template&id=68c6bc16&"
import script from "./AddFlourTypeWeightLinkModal.vue?vue&type=script&lang=js&"
export * from "./AddFlourTypeWeightLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports